"use client";

import { useState } from "react";
import Image from "next/image";
import ImageModal from "./ImageModal";
import { urlFor } from "@/sanity/lib/image";

export default function ImageClientBlock({ item }) {
  const [isOpen, setIsOpen] = useState(false);
  const imageUrl = urlFor(item).width(1000).url();

  return (
    <>
      <div className="flex-1 cursor-zoom-in" onClick={() => setIsOpen(true)}>
        <Image
          src={imageUrl}
          alt={item.alt || item.title}
          width={1000}
          height={1000}
          className="shadow-lg rounded-xl w-full object-contain"
        />
        {item.caption && (
          <p className="mt-4 text-sm text-gray-500 italic text-center mb-10">
            {item.caption}
          </p>
        )}
        {!item.caption && <div className="mb-10" />}
      </div>

      {isOpen && (
        <ImageModal
          src={imageUrl}
          alt={item.alt || item.title}
          caption={item.caption}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
}
